import {
  API_ROUTES,
  API_ROUTE_PREFIX,
  API_ROUTE_PREFIX_HTTPS,
  ICheckCheckoutEligibilityRequestParams,
  IEditTravellersRequestParams,
  IGetNextPageRouteRequestParams,
  IPageRequestParams,
} from "@tm/api-utils";
import { CONTEXT, LOB, PARTNER, PLATFORM } from "@tm/isomorphic-utils";
import { getPartnerOnClientSide, setURLQueryParams } from "../utils";
import { getDeviceIdForClient } from "../utils/getDeviceId";
import { API_HTTPS } from "./config";

export const paymentCheckout = async (reqData: any): Promise<any> => {
  try {
    const { partner = getPartnerOnClientSide(), data } = reqData;
    const params = {
      context: CONTEXT.STANDALONE_V2,
      ins_new_flow: true,
    };
    const urlParams = setURLQueryParams(params);
    const dvid = getDeviceIdForClient();

    const response = await API_HTTPS.post(
      `${API_ROUTE_PREFIX_HTTPS}/${partner}/${API_ROUTES.PAYMENT_CHECKOUT}${
        urlParams ? `?${urlParams}` : ""
      }`,
      data,
      {
        headers: {
          cmp: sessionStorage.getItem("cmp") || undefined,
          dvid: dvid || "",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error", { error });
    throw error;
  }
};

export const sendPolicyEmail = async (data: any): Promise<any> => {
  try {
    const { bookingId, partner } = data;
    const params = { bookingID: bookingId };
    const urlParams = setURLQueryParams(params);
    const dvid = getDeviceIdForClient();
    const response = await API_HTTPS.post(
      `${API_ROUTE_PREFIX}/${partner}/${API_ROUTES.TRIGGER_EMAIL}${
        urlParams ? `?${urlParams}` : ""
      }`,
      {
        headers: {
          cmp: sessionStorage.getItem("cmp"),
          dvid: dvid || "",
        },
      }
    );
    return response?.data;
  } catch (error: any) {
    console.log("Error", { error: error.message });
    throw error;
  }
};

export const editInsuranceDetails = async (
  reqData: IEditTravellersRequestParams
): Promise<any> => {
  try {
    const {
      bookingID,
      partner = getPartnerOnClientSide(),
      data = [],
    } = reqData;

    if (!bookingID)
      throw "editInsuranceDetails: Booking id not present or invalid";

    const urlParams = setURLQueryParams({ bookingID });
    const dvid = getDeviceIdForClient();

    const response = await API_HTTPS.put(
      `${API_ROUTE_PREFIX_HTTPS}/${partner}/${
        API_ROUTES.EDIT_INSURANCE_DETAILS
      }${urlParams ? `?${urlParams}` : ""}`,
      data,
      {
        headers: {
          cmp: sessionStorage.getItem("cmp") || undefined,
          dvid: dvid || "",
        },
      }
    );
    return response?.data;
  } catch (error) {
    console.error("Error", { error });
    throw error;
  }
};

export const getNextPageRouteDetails = async (
  reqData: IGetNextPageRouteRequestParams
) => {
  const { partner = PARTNER.MMT, query, ...data } = reqData;
  const dvid = getDeviceIdForClient();
  const params = {
    lob: LOB.STANDALONE,
    platform: PLATFORM.WEB,
    context: CONTEXT.STANDALONE_V2,
    isCountryCodesSupported: true.toString(),
    partner,
    ...query,
  };

  const urlParams = new URLSearchParams(params).toString();
  let url;
  if (partner === PARTNER.MYPARTNER) {
    url = `${API_ROUTE_PREFIX_HTTPS}/${API_ROUTES.GET_NEXT_PAGE_ROUTE_MYPARTNER}?${urlParams}`;
  } else {
    url = `${API_ROUTE_PREFIX_HTTPS}/${partner}/${API_ROUTES.GET_NEXT_PAGE_ROUTE}?${urlParams}`;
  }

  const response = await API_HTTPS.post(url, data, {
    headers: { dvid: dvid || "" },
  });
  return response.data;
};

export const hitRetailConsentMyPartner = async (
  reqData: IPageRequestParams
) => {
  const { partner = PARTNER.MYPARTNER, query, ...data } = reqData;
  const dvid = getDeviceIdForClient();
  const params = {
    lob: LOB.STANDALONE,
    platform: PLATFORM.WEB,
    context: CONTEXT.STANDALONE_V2,
    isCountryCodesSupported: true.toString(),
    partner,
    ...query,
  };

  const urlParams = new URLSearchParams(params).toString();
  const url = `${API_ROUTE_PREFIX_HTTPS}/${API_ROUTES.HIT_RETAIL_CONSENT}?${urlParams}`;
  const response = await API_HTTPS.post(url, data, {
    headers: { dvid: dvid || "" },
  });
  return response.data;
};

export const getOrdersMyPartner = async (reqData: IPageRequestParams) => {
  const { partner = PARTNER.MYPARTNER, query, ...data } = reqData;
  const dvid = getDeviceIdForClient();
  const params = {
    lob: LOB.STANDALONE,
    platform: PLATFORM.WEB,
    context: CONTEXT.STANDALONE_V2,
    isCountryCodesSupported: true.toString(),
    partner,
    ...query,
  };

  const urlParams = new URLSearchParams(params).toString();
  const url = `${API_ROUTE_PREFIX_HTTPS}/${API_ROUTES.GET_ORDERS_RETAIL_MYPARTNER}?${urlParams}`;
  const response = await API_HTTPS.get(url, {
    params: data,
    headers: { dvid: dvid || "" },
  });
  return response.data;
};

export const checkCheckoutEligibility = async (
  reqData: ICheckCheckoutEligibilityRequestParams
) => {
  const { partner = PARTNER.MMT, query, ...data } = reqData;
  const dvid = getDeviceIdForClient();
  const params = {
    lob: LOB.STANDALONE,
    platform: PLATFORM.WEB,
    context: CONTEXT.STANDALONE_V2,
    isCountryCodesSupported: true.toString(),
    partner,
    ...query,
  };

  const urlParams = new URLSearchParams(params).toString();
  const url = `${API_ROUTE_PREFIX_HTTPS}/${partner}/${API_ROUTES.CHECK_CHECKOUT_ELIGIBILITY}?${urlParams}`;

  const response = await API_HTTPS.post(url, data, {
    headers: { dvid: dvid || "" },
  });
  return response.data;
};
